"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _reactRedux = require("react-redux");
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _Offer = require("../../../../../Results/components/Offer");
var _Hotel = require("../../../../../Results/components/Hotel");
var _actions = require("../../../../../Results/components/OfferDetails/store/actions");
var _selectors3 = require("../../../../store/selectors");
var _actions2 = require("../../../../store/actions");
var _CopyButton = _interopRequireDefault(require("./components/CopyButton"));
var _SearchButton = _interopRequireDefault(require("./components/SearchButton"));
var _DeleteButton = _interopRequireDefault(require("./components/DeleteButton"));
var _Item = _interopRequireDefault(require("./components/Item"));
var _Price = _interopRequireDefault(require("./components/Price"));
var _Comment = _interopRequireDefault(require("./components/Comment"));
var _helpers = require("./helpers");
var _actions3 = require("./store/actions");
var _styles = _interopRequireDefault(require("./styles"));
var _hotelStyles = _interopRequireDefault(require("./hotelStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import CollectionButton from './components/CollectionButton';
var DEFAULT_COUNTRY = {
  id: 0
};
var Offer = function Offer(_ref) {
  var basketID = _ref.basketID,
    className = _ref.className,
    stylesMap = _ref.stylesMap,
    _ref$compactTransport = _ref.compactTransport,
    compactTransport = _ref$compactTransport === void 0 ? false : _ref$compactTransport,
    offerID = _ref.offerID,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    defaultDiscount = _ref.discount,
    defaultMargin = _ref.margin,
    defaultShowPriceWithMargin = _ref.showPriceWithMargin,
    _ref$round = _ref.round,
    defaultRound = _ref$round === void 0 ? false : _ref$round,
    buttons = _ref.buttons,
    dragNode = _ref.dragNode,
    onRemove = _ref.onRemove,
    onSearchOffer = _ref.onSearchOffer;
  var dispatch = (0, _reactRedux.useDispatch)();
  var offerSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getOffer)(), [{
      offerID: offerID
    }]);
  }, [offerID]);
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors3.getTempEditBasketData)(state, {
        basketID: basketID
      });
    }),
    _useSelector$discount = _useSelector.discount,
    discount = _useSelector$discount === void 0 ? defaultDiscount : _useSelector$discount,
    _useSelector$margin = _useSelector.margin,
    margin = _useSelector$margin === void 0 ? defaultMargin : _useSelector$margin,
    _useSelector$showPric = _useSelector.showPriceWithMargin,
    showPriceWithMargin = _useSelector$showPric === void 0 ? defaultShowPriceWithMargin : _useSelector$showPric,
    _useSelector$round = _useSelector.round,
    round = _useSelector$round === void 0 ? defaultRound : _useSelector$round;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors3.getOfferExtra)(state, {
        basketID: basketID,
        offerID: offerID
      });
    }),
    editedPrice = _useSelector2.editedPrice;
  var offer = (0, _reactRedux.useSelector)(offerSelector);
  var hotel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors2.getHotel)()(state, offer.hotelId);
  });
  var currencyCode = offer.currencyLocal,
    hotelId = offer.hotelId;
  var handleOpenMap = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.openMap)(hotelId, offerID));
  }, [dispatch, hotelId, offerID]);
  var onRemoveOffer = (0, _react.useCallback)(function () {
    onRemove(offerID, basketID);
  }, [basketID, offerID, onRemove]);
  var handleShowOfferInSearch = (0, _react.useCallback)(function () {
    onSearchOffer ? onSearchOffer(hotelId, offerID) : dispatch((0, _actions3.toSearchPage)(hotelId, offerID));
  }, [dispatch, hotelId, offerID, onSearchOffer]);
  var nextEditePrice = (0, _react.useCallback)(function (nextEditedValue) {
    if (editedPrice !== nextEditedValue) {
      dispatch((0, _actions2.updateOfferInBasket)(offerID, basketID, {
        editedPrice: nextEditedValue
      }));
    }
  }, [basketID, dispatch, editedPrice, offerID]);
  var currency = (0, _react.useMemo)(function () {
    return (0, _dictionary.getCurrencyByCode)(currencyCode);
  }, [currencyCode]);
  var marginPrice = (0, _helpers.getMarginPrice)(offer.price[currencyCode], margin);
  var discountPrice = (0, _helpers.getDiscountPrice)(marginPrice || offer.price[currencyCode], discount, round);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)((stylesMap === null || stylesMap === void 0 ? void 0 : stylesMap.listItem) || _styles.default.listItem, className, _defineProperty({}, _styles.default.isMobile, isMobile))
  }, dragNode, /*#__PURE__*/_react.default.createElement(_Item.default, {
    isMobile: isMobile,
    className: _styles.default.itemWitBorder
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.listItemBody, _defineProperty({}, _styles.default.isMobile, isMobile))
  }, hotel ? /*#__PURE__*/_react.default.createElement(_Hotel.HotelWithOfferDetails, {
    averageRating: hotel.averageRating,
    city: hotel.city,
    className: _styles.default.hotelWithOffer,
    commentJSX: /*#__PURE__*/_react.default.createElement(_Comment.default, {
      basketID: basketID,
      isMobile: isMobile,
      offerID: offerID
    }),
    country: DEFAULT_COUNTRY,
    district: hotel.district,
    hotelID: hotelId,
    initialCurrencyCode: currencyCode,
    isMobile: isMobile,
    name: hotel.name,
    offerID: offerID,
    photo: hotel.photos[0],
    services: hotel.services,
    stylesMap: _hotelStyles.default,
    sourceRatings: hotel.sourceRatings,
    secondaryStars: hotel.secondaryStars,
    stars: hotel.stars,
    onOpenMap: hotel.location ? handleOpenMap : undefined
  }) : /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.ERROR
  }, "Hotel id as ".concat(hotelId, " has not been found!")), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offer
  }, /*#__PURE__*/_react.default.createElement(_Offer.Transports, {
    compact: compactTransport,
    className: _styles.default.transport,
    date: offer.date,
    flights: offer.flights,
    isMobile: isMobile,
    nights: offer.nights,
    nightsInHotel: offer.nightsInHotel,
    transport: offer.transport
  }), /*#__PURE__*/_react.default.createElement(_Offer.Food, {
    food: offer.food,
    isMobile: isMobile,
    informationOfCrossTour: offer.isCrossTour ? offer.informationOfCrossTour : undefined,
    room: offer.room.name,
    stopsale: offer.stopsale.hotel,
    people: offer.people
  }), /*#__PURE__*/_react.default.createElement(_Price.default, {
    className: _styles.default.price,
    currency: currency,
    discountPrice: discountPrice,
    hotelID: hotelId,
    initialCurrencyCode: currencyCode,
    isHeightPromo: Boolean(offer.heightPromo),
    marginPrice: showPriceWithMargin ? marginPrice : undefined,
    offerID: offerID,
    operatorID: offer.operator,
    promoText: offer.promo || offer.heightPromo || undefined,
    editedPrice: editedPrice,
    onEditingPrice: nextEditePrice
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.buttonsRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.buttonsCol
  }, buttons, /*#__PURE__*/_react.default.createElement(_CopyButton.default, {
    offerID: offerID,
    basketID: basketID
  }), /*#__PURE__*/_react.default.createElement(_DeleteButton.default, {
    onClick: onRemoveOffer
  }), /*#__PURE__*/_react.default.createElement(_SearchButton.default, {
    onClick: handleShowOfferInSearch
  })))));
};
Offer.propTypes = {
  basketID: _propTypes.default.number.isRequired,
  compactTransport: _propTypes.default.bool,
  discount: _propTypes.default.number,
  round: _propTypes.default.bool,
  offerID: _propTypes.default.string.isRequired,
  margin: _propTypes.default.number,
  showPriceWithMargin: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  buttons: _propTypes.default.element,
  dragNode: _propTypes.default.element,
  onRemove: _propTypes.default.func,
  onSearchOffer: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(Offer);